<template>
  <div>
    <productDetail :productId="null"/>
  </div>
</template>

<script>

import ProductDetail from '@/components/catalog/ProductDetail'

export default {
  name: 'new-product-view',
  components: {
    ProductDetail
  }
}
</script>



// WEBPACK FOOTER //
// src/views/NewProductView.vue